module.exports = __webpack_public_path__ + "static/media/next.72c58e9d.svg";